<template>
  <button v-if="webShareApiSupported" class="button button-basic" @click="openSharePanel">
    <svg class="icon icon-small" role="img" aria-label="Share resource">
      <title>Share resource</title>
      <use xlink:href="/images/fa-icons.svg#share"></use>
    </svg>
  </button>

  <dropdown-menu v-else type="button button-basic" position="left">
    <template #label>
      <svg class="icon icon-small" role="img" aria-label="Share resource">
        <title>Share resource</title>
        <use xlink:href="/images/fa-icons.svg#share"></use>
      </svg>
    </template>

    <ul class="no-list">
      <li>
        <a
          :href="constructFacebookUrl"
          title="Share on Facebook"
          class="button button-outlined"
          target="_blank"
          rel="noopener"
          @click="eventResourceShared('Facebook')"
        >
          <svg class="icon icon-small icon-facebook !tw-mr-2" role="img" aria-label="Facebook">
            <use xlink:href="/images/fa-icons.svg#facebook"></use>
          </svg>
          Facebook
        </a>
      </li>
      <li>
        <a
          :href="constructTwitterUrl"
          title="Share on Twitter"
          class="button button-outlined"
          target="_blank"
          rel="noopener"
          @click="eventResourceShared('Twitter')"
        >
          <svg class="icon icon-small icon-twitter !tw-mr-2" role="img" aria-label="Twitter">
            <use xlink:href="/images/fa-icons.svg#twitter"></use>
          </svg>
          Twitter
        </a>
      </li>
      <li>
        <a
          :href="constructPinterestUrl"
          title="Share on Pinterest"
          class="button button-outlined"
          target="_blank"
          rel="noopener"
          @click="eventResourceShared('Pinterest')"
        >
          <svg class="icon icon-small icon-pinterest !tw-mr-2" role="img" aria-label="Pinterest">
            <use xlink:href="/images/fa-icons.svg#pinterest"></use>
          </svg>
          Pinterest
        </a>
      </li>
      <li>
        <a
          :href="constructEmailUrl"
          title="Share on Email"
          class="button button-outlined"
          @click="eventResourceShared('Email')"
        >
          <svg class="icon icon-small !tw-mr-2" role="img" aria-label="Email">
            <use xlink:href="/images/fa-icons.svg#envelope"></use>
          </svg>
          Email
        </a>
      </li>
    </ul>
  </dropdown-menu>
</template>

<script>
/* Share Links
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components:
 * @methods:
 */

import DropdownMenu from '~/components/DropdownMenu.vue';

export default {
  name: 'ShareLinks',
  components: {
    DropdownMenu,
  },
  props: {
    resource: {
      type: Object,
      default: () => {
        return {};
      },
    },
    eventParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      resourceUrl: this.$config.baseURL + this.resource.link,
      resourceType: this.resource.type.replace('-', ' '),
      webShareApiSupported: false,
    };
  },
  computed: {
    constructFacebookUrl() {
      return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(this.resourceUrl);
    },
    constructTwitterUrl() {
      return (
        'https://twitter.com/intent/tweet?url=' +
        encodeURI(
          this.resourceUrl +
            '&text=' +
            'Here is a cool ' +
            this.resourceType +
            ' I found: ' +
            this.resource.name
        )
      );
    },
    constructPinterestUrl() {
      return (
        'https://pinterest.com/pin/create/button/?url=' +
        encodeURI(this.resourceUrl + 'description=' + this.resource.name)
      );
    },
    constructEmailUrl() {
      // Share resource via email
      return encodeURI(
        'mailto:?subject=Teach Starter resource: ' +
          this.resource.name +
          "&body=Here's a resource you might like: \n\n" +
          this.resource.name +
          '\n' +
          this.resource.excerpt +
          ' \n\nView and download: ' +
          this.resourceUrl +
          '\n\n- Teach Starter'
      );
    },
  },
  mounted() {
    this.webShareApiSupported = navigator.share;
  },
  methods: {
    openSharePanel() {
      navigator.share({
        title: this.resource.name,
        text: 'Teach Starter ' + this.resourceType,
        url: this.resourceUrl,
      });
      let pageType = this.resource.type
        .trim()
        .replace(/[\s-]+/g, '_')
        .toLowerCase();
      let productAreas = '';
      if (pageType === 'teaching_resource') {
        pageType = 'resource';
        productAreas = 'resources';
      } else if (pageType === 'unit_plan') {
        productAreas = 'unit_plan';
      } else if (pageType === 'blog') {
        productAreas = 'content';
      } else if (pageType === 'podcast') {
        productAreas = 'content';
      } else if (pageType === 'resource_pack') {
        pageType = 'pack';
        productAreas = 'pack';
      } else if (pageType === 'widget') {
        productAreas = 'widget';
      } else if (pageType === 'lesson_plan') {
        productAreas = 'lesson_plan';
      }
      const analyticsName = `${pageType}.share`;

      this.$mzAnalyticsApi({
        event: 'click',
        name: analyticsName,
        productArea: productAreas,
        entityType: pageType,
        entityId: this.resource.id,
      });
    },
    eventResourceShared(type) {
      if (!this.eventParams) {
        return {};
      }
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.button) {
  align-items: center;
  display: flex;
  font-size: $font-size-300;
  margin: 0;

  .icon {
    flex: 0 0 auto;
    bottom: 1px;
  }
}

:deep(.icon-facebook) {
  color: $color-facebook;
}

:deep(.icon-twitter) {
  color: $color-twitter;
}

:deep(.icon-pinterest) {
  color: $color-pinterest;
}
</style>
